import { Box, Grid, Typography } from '@mui/material';
import { FC, useEffect, useRef } from 'react';
import { TagsProps } from '../../';
import {
  ArticleFormat,
  BrandKey,
  GetArticleQuery_query_article_Article_tags_ArticleTag_tag_Tag,
  GetSuggestedTagsListQuery_query_suggestTags_Tag,
  TagType,
  TvSearchContextType,
} from '../../../../__generated__/queries-web';
import { TagItem } from '../../TagItem';
import { useEditableTag } from '../../useEditTag';
import { useStyles as useSharedStyles } from '../styles';
import { SearchDropdown } from './SearchDropdown';

interface ProgramsProps extends Pick<TagsProps, 'article' | 'onTagsChange'> {
  brandKey: BrandKey;
  field: string;
  suggestedTagList: GetSuggestedTagsListQuery_query_suggestTags_Tag[];
  tags: GetArticleQuery_query_article_Article_tags_ArticleTag_tag_Tag[];
}

export const TagProgramTv: FC<ProgramsProps> = ({
  article,
  brandKey,
  field,
  onTagsChange,
  tags: selectedTags,
}) => {
  const isFirstRender = useRef(true);

  const {
    newTags,
    handlers: { handleAddTag, handleDeleteTag },
  } = useEditableTag<
    GetArticleQuery_query_article_Article_tags_ArticleTag_tag_Tag
  >(selectedTags, brandKey);

  const selectedProgramList = selectedTags.filter(({ type }) => {
    return type === TagType.TvProgram || type === TagType.TvCollection;
  });

  const sharedClasses = useSharedStyles({
    selectedTagListLength: selectedProgramList.length,
  });

  useEffect(() => {
    if (isFirstRender.current) {
      // eslint-disable-next-line immutable/no-mutation
      isFirstRender.current = false;
      return;
    }

    newTags && onTagsChange(newTags, field);
  }, [field, newTags, onTagsChange]);

  return (
    <Grid
      alignItems="flex-end"
      className={sharedClasses.wrapper}
      container
      justifyContent="space-between"
    >
      <Grid item xs={4}>
        <Typography className={sharedClasses.subTitle} component="h3">
          TV
          <span>({selectedProgramList.length})</span>
        </Typography>
      </Grid>

      <Grid item xs={8}>
        <SearchDropdown
          handleAddTag={handleAddTag}
          searchContext={
            article?.format === ArticleFormat.Rich
              ? TvSearchContextType.Rich
              : TvSearchContextType.Video
          }
        />
      </Grid>
      <Box className={sharedClasses.innerWrapper} component="section">
        {selectedProgramList.map((program) => (
          <TagItem
            {...program}
            key={program.title}
            onDelete={handleDeleteTag}
          />
        ))}

        {!selectedProgramList.length && (
          <Typography component="p">Aucun programme TV selectionné</Typography>
        )}
      </Box>
    </Grid>
  );
};
